import { render } from "./BottomBarManager.vue?vue&type=template&id=5c925a26"
import script from "./BottomBarManager.vue?vue&type=script&lang=js"
export * from "./BottomBarManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__